import { Text } from '@bechtel/gds';
import { Status, Wrapper } from '@googlemaps/react-wrapper';
import React, { useEffect, useRef } from 'react';
import LoadingIndicator from '~/components/loading-indicator';
import { envConfig } from '~/env-config';
import { MapComponentProps, MapProps } from './types';
const render = (status: Status) => {
  if (status === Status.FAILURE) return <Text>Error</Text>;
  return <LoadingIndicator />;
};

export const MapComponent: React.FC<MapComponentProps> = ({ children, style, center, zoom, mapTypeId }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [map, setMap] = React.useState<google.maps.Map>();
  const infoWindow = new window.google.maps.InfoWindow();
  useEffect(() => {
    if (ref.current && !map) {
      setMap(new window.google.maps.Map(ref.current, { center, zoom, mapTypeId, disableDefaultUI: true }));
    }
  }, [ref, center, zoom, map, mapTypeId]);

  return (
    <>
      <div ref={ref} style={style} />
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, { map, infoWindow });
        }
      })}
    </>
  );
};

export const Map: React.FC<MapProps> = ({ children }) => {
  return (
    <Wrapper apiKey={envConfig.mapApiKey} render={render}>
      {children}
    </Wrapper>
  );
};
